import cn from 'classnames';
import { HTMLAttributes } from 'react';
import styles from './card.module.scss';


export function CardContent ({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
    return (
        <div
            className={ cn(styles.content, className) }
            data-template="card-content"
            { ...props }
        />
    );
}
